<template>
  <div v-if="numberOfAttachments != null && numberOfAttachments > 0">
    <Badge color="white" style="cursor: pointer" @click="openGallery">
      <i class="fas fa-paperclip" style="font-size: 0.855em; line-height: 1" />
      {{ numberOfAttachments }}
    </Badge>
    <FMFileViewerModal v-if="showGallery" v-model:visible="showGallery" :files="sortedFiles" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, type PropType } from "vue";
import Badge from "./BadgeComponent.vue";
import FMFileViewerModal from "@/modules/filemanagement/components/FMFileViewerModal.vue";
import type { FMFileForGallery } from "@/modules/filemanagement/components/FMFileUploadHelper";

const props = defineProps({
  files: {
    type: Array as PropType<FMFileForGallery[] | null>,
    default: null,
  },
});

const sortedFiles = computed(() => {
  if (!props.files) {
    return [];
  }
  return [...props.files].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
});

const numberOfAttachments = computed(() => props.files?.length);

const showGallery = ref(false);
function openGallery() {
  showGallery.value = true;
}
</script>

<style lang="scss" scoped></style>
